import * as ko from "knockout";

export class team_member {
  team_id: KnockoutObservable<string>;
  description: KnockoutObservable<string>;

  constructor(item: any) {
    this.team_id = ko.observable(item.team_id);
    if (item.description) this.description = ko.observable(item.description);
    else this.description = ko.observable(item.team_id);
    if (item.team && item.team.description) this.description = ko.observable(item.team.description);
  }
}
